export const standardAfATiers = [
  { id: 'pre1925', completionBefore: 1925, annualRate: 0.025, usefulLifeYears: 40 },
  { id: '1925to2022', completionFrom: 1925, completionBefore: 2023, annualRate: 0.02, usefulLifeYears: 50 },
  { id: 'post2022', completionFrom: 2023, annualRate: 0.03, usefulLifeYears: 33 },
];

export const degressiveAfA = {
  annualRate: 0.05,
  applicableFrom: 2023,
  switchToLinearRate: 0.03,
};

export const denkmalschutzAfA = {
  rental: [
    { yearsFrom: 1, yearsTo: 8, annualRate: 0.09 },
    { yearsFrom: 9, yearsTo: 12, annualRate: 0.07 },
  ],
};

export const renovationRules = {
  anschaffungsnaheThreshold: 0.15,
  anschaffungsnahePeriodYears: 3,
};

export const landBuildingSplitRanges = [
  { location: 'Munich (prime)', min: 0.50, max: 0.80 },
  { location: 'Berlin, Hamburg, Frankfurt', min: 0.40, max: 0.70 },
  { location: 'Medium cities', min: 0.25, max: 0.50 },
  { location: 'Small cities / suburban', min: 0.20, max: 0.40 },
  { location: 'Rural areas', min: 0.10, max: 0.30 },
];
